export default {
  state: () => ({
    siteInfo: null,
    currencyList: null,
    defaultCurrency: {
      code: 'KZT',
    },
    seoData: null,
  }),
  mutations: {
    UPDATE_SITE_INFO(state, value) {
      state.siteInfo = value
      if (value.isWebview) {
        document.querySelector('body').classList.add('web-view')
      }
    },
    UPDATE_SEO_DATA(state, value) {
      state.seoData = value
    },
    UPDATE_CURRENCY_LIST(state, value) {
      state.currencyList = value
    },
    UPDATE_DEFAULT_CURRENCY(state, value) {
      state.defaultCurrency = value
    },
    UPDATE_FULL_CHECK(state, value) {
      if (state.siteInfo) {
        state.siteInfo = { ...state.siteInfo, fullCheck: value }
      }
    },
  },
  actions: {
    setCurrencyData({ commit }, payload) {
      commit('UPDATE_CURRENCY_LIST', payload.currencies)
      commit('UPDATE_DEFAULT_CURRENCY', payload.defaultCurrency)
    },
    setSiteInfo({ commit }, payload) {
      commit('UPDATE_SITE_INFO', payload)
    },
  },
  getters: {
    getCountryCode: (s, g) => (g.getUserRegion ? g.getUserRegion : s.siteInfo?.region),
    getCurrencyList: (s) => s.currencyList,
    getCurrency: (s, g) => (g.getUserCurrency ? g.getUserCurrency : s.defaultCurrency),
    getCurrencyCode: (s, g) => g.getCurrency.code,
    getCurrencyCodeById: (s, g) => (id) => {
      return g.getCurrencyList?.find((currency) => currency.objId === id)?.code || s.defaultCurrency?.code
    },
    siteInfoLoaded: (s) => !!s.seoData,
    getMainDomain: (s) => s.siteInfo?.mainDomain ?? null,
    autoAcceptRules: (s) => s.siteInfo?.autoAcceptRules ?? false,
    isWebView: (s) => {
      if (process.env.WEBVIEW === '1') {
        return true
      }
      return s.siteInfo?.isWebview ?? false
    },
    getCurrentDomain: (s) => s.siteInfo?.domain ?? null,
    getMetaTitle: (s) => s.seoData?.metaTitle ?? null,
    getMetaDescription: (s) => s.seoData?.metaDescription ?? null,
    getSeoDescription: (s) => s.seoData?.seoText ?? null,
    getUserIp: (s) => s.siteInfo?.realIp ?? null,
    getRegion: (s) => s.siteInfo?.region ?? null,
    getRealRegion: (s) => s.siteInfo?.realRegion ?? null,
    getAvailableRegions: (s) => s.siteInfo?.availableRegions ?? null,
    getShowDocNum: (s) => s.siteInfo?.showDocNum ?? false,
    getBotLanguage: (s) => {
      if (s.siteInfo?.botLanguages?.length) {
        return s.siteInfo.botLanguages[0]
      }
      return null
    },
    getFullCheck: (s) => s.siteInfo?.fullCheck,
  },
}
